// Auth
export const SAVE_AUTH='SAVE_AUTH';
export const LOGOUT='LOGOUT';


// Template
export const SAVE_TEMPLATE_CAT_RELEVANCE='SAVE_TEMPLATE_CAT_RELEVANCE';
export const SAVE_TEMPLATE_TOPIC_RELEVANCE='SAVE_TEMPLATE_TOPIC_RELEVANCE';
export const ADD_TEMPLATE_CATEGORY='ADD_TEMPLATE_CATEGORY';
export const REMOVE_TEMPLATE_CATEGORY='REMOVE_TEMPLATE_CATEGORY';
export const ADD_TEMPLATE_TOPIC='ADD_TEMPLATE_TOPIC';
export const REMOVE_TEMPLATE_TOPIC='REMOVE_TEMPLATE_TOPIC';
export const SAVE_TEMPLATE_CATEGORY_ORDER='SAVE_TEMPLATE_CATEGORY_ORDER';
export const SAVE_TEMPLATE_TOPIC_ORDER='SAVE_TEMPLATE_TOPIC_ORDER';
export const SET_TEMPLATE_EDITING='SET_TEMPLATE_EDITING';
export const SET_DEFAULT_TEMPLATES='SET_DEFAULT_TEMPLATES';
export const SET_USER_TEMPLATES='SET_USER_TEMPLATES';
export const SET_USER_TEMPLATES_STATUS='SET_USER_TEMPLATES_STATUS';
export const SET_TEMPLATE_ERRORS_IDS='SET_TEMPLATE_ERRORS_IDS';
export const SAVE_TEMPLATE_TITLE='SAVE_TEMPLATE_TITLE';


// Topic (fixed topics)
export const GET_OFFICIAL_TOPICS='GET_OFFICIAL_TOPICS';
export const SET_TOPICS='SET_TOPICS';


// Calculation
export const SET_CALCULATING='SET_CALCULATING';
export const SET_CALCULATING_TOPIC='SET_CALCULATING_TOPIC';
export const SET_CALCULATING_CATEGORY='SET_CALCULATING_CATEGORY';
export const SET_CALCULATING_COUNTRY='SET_CALCULATING_COUNTRY';
export const SET_CALCULATION_STATUS='SET_CALCULATION_STATUS';
export const SET_CALCULATION_LIST='SET_CALCULATION_LIST';
export const SET_CALCULATION_DEFAULT_API_DATA='SET_CALCULATION_DEFAULT_API_DATA';
export const DELETE_CALCULATION='DELETE_CALCULATION';